<template>
  <base-table
    v-if="showTable"
    title="Documents"
    titleSingle="Document"
    :headers="headers"
    :items="testdocuments"
    :valid="valid"
    :loading="loading"
    :add="!readOnly"
    @get-items="getTestDocuments"
    @post-item="postTestDocuments"
    @view-item="onDownloadItem"
    @delete-item="deleteTestDocuments"
    @modal-close="resetForm"
  >
    <v-form ref="form" v-model="valid">
      <br />
      <v-file-input
        label="Upload"
        type="file"
        show-size
        v-model="file"
        outlined
        :loading="uploadLoading"
      ></v-file-input>
    </v-form>
  </base-table>
</template>

<script>
import TestDocumentService from "@/services/TestDocumentService.js";
import BaseTable from "@/components/tables/BaseTable.vue";
import fileDownload from "js-file-download";

export default {
  name: "TestDocumentTable",
  components: {
    BaseTable
  },
  props: {
    readOnly: Boolean,
    testId: String
  },
  data() {
    return {
      headers: [
        { text: "Name", value: "name" },
        { text: "Filename", value: "filename" },
        { text: "Type", value: "type" },
        {
          text: "Actions",
          value: this.readOnly ? "downloadItem" : "deleteItem"
        }
      ],
      testdocuments: [],
      testdocument: {
        testdocumentId: "",
        name: "",
        filename: "",
        type: ""
      },
      file: null,
      valid: true,
      loading: true,
      uploadLoading: false
    };
  },
  watch: {
    testId() {
      this.getTestDocuments();
    }
  },
  computed: {
    showTable() {
      return !this.readOnly || (this.readOnly && this.testdocuments.length > 0);
    }
  },
  methods: {
    getTestDocuments() {
      this.loading = true;
      TestDocumentService.getTestDocumentsByTestId(this.testId)
        .then(response => {
          this.testdocuments = response;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    putTestDocuments() {
      if (this.$refs.form.validate()) {
        TestDocumentService.putTestDocument(this.testdocument).then(() => {
          this.getTestDocuments(),
            this.$snackbarSuccess("Document Successfully Added");
        });
      }
    },
    async postTestDocuments() {
      if (this.$refs.form.validate()) {
        if (this.file != null) {
          try {
            this.uploadLoading = true;
            const formData = new FormData();
            formData.append("file", this.file);

            await TestDocumentService.postTestDocument(formData, this.testId);
          } finally {
            await this.getTestDocuments();
            this.uploadLoading = false;
            this.documentCreateDialog = false;
          }
        }
      }
    },
    editTestDocuments(item) {
      this.testdocument = Object.assign({}, item);
    },
    deleteTestDocuments(item) {
      TestDocumentService.deleteTestDocument(item.testDocumentId).then(() => {
        this.getTestDocuments(), this.$snackbarSuccess("Document Deleted");
      });
    },

    async onDownloadItem(item) {
      try {
        const file = await TestDocumentService.getFile(item.testDocumentId);

        fileDownload(
          new Blob([file.data], {
            type: file.extension ? file.extension : undefined
          }),
          item.filename
        );
      } catch (error) {
        this.$snackbarError("Document download failed");
      }
    },
    resetForm() {
      // Doesn't clear everything since an edit pulls in extra fields
      // Does that matter?
      this.$refs.form.reset();
    }
  }
};
</script>

<style scoped></style>
